import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../layout";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "gatsby"

export default class Error404 extends React.Component {
  render() {
    return (
      <Layout>
        <div className="container 404-container">
          <Helmet title={config.siteTitle} />
          <SEO />
          Oops! Page not found. Go to <Link to="/">home</Link>.
        </div>
      </Layout>
    );
  }
}
